module.exports = __webpack_public_path__ + "img/6ca159f5fa173e0df55251dc4f4c3261.png";